var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-empty',{attrs:{"image":_vm.image,"image-style":{
    height: _vm.height,
  }}},[_c('span',{staticClass:"title",attrs:{"slot":"description"},slot:"description"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }